module.exports = __webpack_public_path__ + "static/img/yuzhu-1.e940363.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/yuzhu-1.png
// module id = weEk
// module chunks = 0